import SafetyRatings from './SafetyRatings';

export default SafetyRatings;
